import { motion } from 'framer-motion';
import { useLanguage } from '../../i18n/LanguageContext';

export default function Privacy() {
  const { t } = useLanguage();
  return (
    <section id="privacy" className="bg-ev-ink py-24 md:py-32 px-6 md:px-10" data-testid="privacy-section">
      <div className="max-w-[1100px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-[760px] mb-12">
          <p className="font-body text-[10px] uppercase tracking-[0.4em] text-ev-lime mb-6">{t.pv_label}</p>
          <h2
            className="font-display font-light text-white lowercase mb-6"
            style={{ fontSize: 'clamp(2rem, 5vw, 4rem)', letterSpacing: '-0.03em' }}>
            {t.pv_h}
          </h2>
          <p className="font-body text-base md:text-lg text-white/70 leading-relaxed mb-6">{t.pv_sub}</p>
          <p className="font-body italic text-lg md:text-xl text-white leading-relaxed">
            &ldquo;{t.pv_scope}&rdquo;
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-12">
          {t.pv_live.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.5 }}
              className="flex items-start gap-3"
              data-testid={`privacy-live-${i}`}>
              <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-ev-lime mt-2" />
              <p className="font-body text-sm md:text-base text-white/80 leading-relaxed">{item}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="border-t border-white/10 pt-10">
          <p className="font-body text-base md:text-lg text-white/80 leading-relaxed max-w-[760px]">
            {t.pv_promise}
          </p>
        </motion.div>
      </div>
    </section>
  );
}
